// min date format YYYY-MM-DD
export const MIN_BLUEBIRD_DATE = new Date('2020-01-01');

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export enum DateFormatsEnum {
  Full = "yyyy-MM-dd'T'HH:mm:ss",
  Start = "yyyy-MM-dd'T00:00:00.000Z'",
  End = "yyyy-MM-dd'T23:59:59.000Z'",
  yyyyMMdd = 'yyyy-MM-dd',
  ddMMMyyyy = 'dd MMM yyyy',
  MM_dd_yyyy = 'MM-dd-yyyy',
  FullHumanReadable = "dd MMM yyyy, HH:mm:ss '(UTC)'",
  FullHumanReadableWithoutUTC = 'dd MMM yyyy, HH:mm:ss ',
  ShortHumanReadable = 'dd MMM yyyy, HH:mm',
  FullAutomated = "MM-dd-yyyy, HH:mm:ss '(UTC)'",
  TimeOnly = 'HH:mm:ss',
  FullDateAndTime = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
}

export const DEFAULT_TIMEZONE = {
  value: 'UTC',
  abbr: 'UTC',
  offset: 0,
  isdst: false,
  text: '(UTC) Coordinated Universal Time',
  utc: ['America/Danmarkshavn', 'Etc/GMT'],
};

export const UTC = 'UTC';
